// Generated by ts-to-zod
import {z} from "zod";
import {mantineCssLengthSchema} from "./primitives.zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineImagePropsSchema = z.strictObject({
	fit: z.string().optional(),
	fallbackSrc: z.string().optional(),
	h: mantineCssLengthSchema.optional(),
	w: mantineCssLengthSchema.optional(),
	radius: mantineSpacingSchema.optional(),
	mah: mantineCssLengthSchema.optional(),
	maw: mantineCssLengthSchema.optional(),
});
